/* oxlint-disable */
import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

import { routes } from '@/features/v2/constants/routes';

import { useUrlParams } from './useUrlParams';

export const useRedirectionPayphone = () => {
  const { payphone } = useUrlParams();
  const router = useRouter();

  useEffect(() => {
    if (payphone) {
      router.push(`${routes.DEPOSIT}/success?success=${payphone}`);
    }
  }, [payphone]);
};
